/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../../../_metronic/helpers'
import { propTypes } from 'react-bootstrap/esm/Image';
import { BranchAddModal } from './BranchAddModal';
import axios from 'axios';

const API_URL_API = process.env.REACT_APP_API_URL_BACKEND
export const GET_ALL_ORGANIZATIONS_URL = `${API_URL_API}/organization`

type Props = {
  className : string,
  branches : any,
  getAllBranches : any
}

const BranchTable: React.FC<Props> = ({className, branches, getAllBranches}) => {

    const [showModal, setShowModal] = useState(false);
    const [data, setData] = useState(null);
    const [edit, setEdit] = useState(false);
    const [organizations, setOrganizations] = useState([]);

    const toggleShow = (branchId:any)  => {
        

        setEdit(false);
        if(branchId !== 0){
          setEdit(true);
          branches.map((branch:any)=> {
            if(branchId === branch.id){
              setData(branch);
            }
          });
        
        }

        setShowModal(pre => !pre);

        if(showModal){
          console.log('toggleShow ' + branchId);
          getAllBranches();
        }

        getAllOrganizations();
    }

    const getAllOrganizations = async () => {
    
      try {
        const {data: result} = await axios.get(GET_ALL_ORGANIZATIONS_URL);
        setOrganizations(result.data);
      } catch (err) {
        console.log(err)
      }     
    };

    const deleteBranch = async (branchId:any) => {
      //delete organization
      try
      {
        await fetch(process.env.REACT_APP_API_URL_BACKEND + '/branch/', 
        {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({'branch_id': branchId})
        });
        
        getAllBranches();
      }
      catch(error)
      {
        console.log(error);
      }

    }

  return (
    <>
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Branches</span>
        </h3>
        <div className='card-toolbar'>
          <button onClick={() => toggleShow(0)} className='btn btn-sm btn-light-primary'>
            <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
            Add Branch
          </button>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted bg-light'>
                <th className='min-w-200px text-start rounded-start'>Org</th>
                <th className='ps-4 min-w-250px rounded-start'>Name</th>
                <th className='ps-4 min-w-100px rounded-start'>Phone</th>
                <th className='ps-4 min-w-100px text-start rounded-start'>Email</th>
                <th className='ps-4 min-w-325px rounded-start'>Location</th>
                <th className='ps-4 min-w-100px text-start rounded-end'>Status</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
                {branches.map((branch:any) => (
                    <tr key={`branch-${branch.id}`}>
                        <td>
                          <span className='text-dark fw-bold mb-1 fs-6'>
                            <KTSVG path='/media/icons/duotune/arrows/arr071.svg' className='svg-icon-2' /> 
                            {branch.organization.name}
                          </span>
                        </td>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{branch.name}</span></td>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{branch.phone_number}</span></td>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{branch.email_address}</span></td>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{branch.location}</span></td>
                        <td><span className='text-dark fw-bold mb-1 fs-6'>{branch.status? 'Active':'In-Active'}</span></td>
                        <td className='text-end'>
                            <a href='#' onClick={() => toggleShow(branch.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                            <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                            </a>
                            <a href='#' onClick={() => deleteBranch(branch.id)} className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                            <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
                            </a>
                        </td>
                    </tr>
                )
                )}


            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
    {
        showModal ? <BranchAddModal toggleShow={toggleShow} isUpdate={edit} itemToEdit={data} orgList={organizations} /> : null
    }
    </>
  )
}

export {BranchTable}
